import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Button, Message } from 'semantic-ui-react'

import AppUtils from '../../utils/AppUtils'
import AppConstants from '../../utils/AppConstants'
import ColumnsProvider from '../../utils/ColumnsProvider'
import Page from '../../components/elements/Page'
import Header from '../../components/elements/Header'
import Table from '../../components/elements/Table'
import Confirm from '../../components/elements/Confirm'
import ManageColorsPopup from '../popups/colors/ManageColorsPopup'
import CreateCategoryPopup from '../popups/categories/CreateCategoryPopup'
import UpdateCategoryPopup from '../popups/categories/UpdateCategoryPopup'
import CreateProductPopup from '../popups/products/CreateProductPopup'
import UpdateProductBasicPopup from '../popups/products/UpdateProductBasicPopup'
import Grant from '../elements/Grant'

import Types from '../../actions/Types'
import ListAction from '../../actions/categories/ListAction'
import ReorderCategoryAction from '../../actions/categories/ReorderAction'
import DeleteCategoryAction from '../../actions/categories/DeleteAction'
import ReorderProductAction from '../../actions/products/ReorderAction'
import DeleteProductAction from '../../actions/products/DeleteAction'
import ClearErrorAction from '../../actions/app/ClearErrorAction'

class ProductsManagePage extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      selected: null,
      isColorsPopupOpen: false,
      isCreateCategoryPopupOpen: false,
      updateCategoryPopupId: null,
      deleteCategoryId: null,
      isCreateProductPopupOpen: false,
      updateProductPopupId: null,
      deleteProductId: null
    }

    // Bind events
    this.onSelectCategory = this.onSelectCategory.bind(this)
    this.onClickReorderCategory = this.onClickReorderCategory.bind(this)
    this.onClickReorderProduct = this.onClickReorderProduct.bind(this)
    this.onClickManageColors = this.onClickManageColors.bind(this)
    this.onCloseManageColors = this.onCloseManageColors.bind(this)
    this.onClickCreateCategory = this.onClickCreateCategory.bind(this)
    this.onCloseCreateCategory = this.onCloseCreateCategory.bind(this)
    this.onClickUpdateCategory = this.onClickUpdateCategory.bind(this)
    this.onCloseUpdateCategory = this.onCloseUpdateCategory.bind(this)
    this.onClickDeleteCategory = this.onClickDeleteCategory.bind(this)
    this.onConfirmDeleteCategory = this.onConfirmDeleteCategory.bind(this)
    this.onClickCreateProduct = this.onClickCreateProduct.bind(this)
    this.onCloseCreateProduct = this.onCloseCreateProduct.bind(this)
    this.onClickUpdateProduct = this.onClickUpdateProduct.bind(this)
    this.onCloseUpdateProduct = this.onCloseUpdateProduct.bind(this)
    this.onClickDeleteProduct = this.onClickDeleteProduct.bind(this)
    this.onConfirmDeleteProduct = this.onConfirmDeleteProduct.bind(this)
  }

  componentDidMount() {
    this.props.fetch()
  }

  componentDidUpdate(prevProps, prevState) {
    // After having reordered a category, update status and reload
    if (
      prevProps.categoryReorderIsFetching
      &&
      !this.props.categoryReorderIsFetching
    ) {
      AppUtils.setStatus(
        this.props.categoryReorderError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.categoryReorderError
          ? AppUtils.errorToText(this.props.categoryReorderError)
          : 'Catégorie réordonnée.'
      )
      if (!this.props.categoryReorderError) {
        this.props.fetch()
      }
    }

    // After a category has been deleted, refresh
    if (
      prevProps.categoryDeleteIsFetching
      &&
      !this.props.categoryDeleteIsFetching
    ) {
      this.setState({
        deleteCategoryId: null
      })
      AppUtils.setStatus(
        this.props.categoryDeleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.categoryDeleteError
          ? AppUtils.errorToText(this.props.categoryDeleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Cette catégorie contient du matériel.'
            })
          : 'Catégorie supprimée.'
      )
      if (!this.props.categoryDeleteError) {
        this.props.fetch()
      }
    }

    // After having reordered a product, update status and reload
    if (
      prevProps.productReorderIsFetching
      &&
      !this.props.productReorderIsFetching
    ) {
      AppUtils.setStatus(
        this.props.productReorderError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.productReorderError
          ? AppUtils.errorToText(this.props.productReorderError)
          : 'Matériel réordonné.'
      )
      if (!this.props.productReorderError)
      {
        this.props.fetch()
      }
    }

    // After a product has been deleted, refresh
    if (
      prevProps.productDeleteIsFetching
      &&
      !this.props.productDeleteIsFetching
    ) {
      this.setState({
        deleteProductId: null
      })
      AppUtils.setStatus(
        this.props.productDeleteError
          ? AppConstants.STATUS.TYPE.FAILURE
          : AppConstants.STATUS.TYPE.SUCCESS,
        this.props.productDeleteError
          ? AppUtils.errorToText(this.props.productDeleteError, {
              [AppConstants.ERROR.BAD_REQUEST.RESOURCE_IN_USE]: 'Ce matériel contient des pièces.'
            })
          : 'Matériel supprimé.'
      )
      if (!this.props.productDeleteError) {
        this.props.fetch()
      }
    }
  }

  onSelectCategory(id) {
    return () => {
      this.setState({
        selected: id
      })
    }
  }

  onClickReorderCategory(id, direction) {
    return () => {
      this.props.reorderCategory(id, { direction })
    }
  }

  onClickReorderProduct(id, direction) {
    return () => {
      this.props.reorderProduct(id, { direction })
    }
  }

  onClickManageColors() {
    this.setState({
      isColorsPopupOpen: true
    })
  }

  onCloseManageColors(isDirty) {
    this.setState({
      isColorsPopupOpen: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickCreateCategory() {
    this.setState({
      isCreateCategoryPopupOpen: true
    })
  }

  onCloseCreateCategory(isDirty) {
    this.setState({
      isCreateCategoryPopupOpen: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickUpdateCategory(id) {
    return () => {
      this.setState({
        updateCategoryPopupId: id
      })
    }
  }

  onCloseUpdateCategory(isDirty) {
    this.setState({
      updateCategoryPopupId: null
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDeleteCategory(id) {
    return () => {
      this.setState({
        deleteCategoryId: id
      })
    }
  }

  onConfirmDeleteCategory(proceed) {
    if (proceed) {
      this.props.deleteCategory(this.state.deleteCategoryId)
    }
    else {
      this.setState({
        deleteCategoryId: null
      })
    }
  }

  onClickCreateProduct() {
    this.setState({
      isCreateProductPopupOpen: true
    })
  }

  onCloseCreateProduct(isDirty) {
    this.setState({
      isCreateProductPopupOpen: false
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickUpdateProduct(id) {
    return () => {
      this.setState({
        updateProductPopupId: id
      })
    }
  }

  onCloseUpdateProduct(isDirty) {
    this.setState({
      updateProductPopupId: null
    })
    if (isDirty) {
      this.props.fetch()
    }
  }

  onClickDeleteProduct(id) {
    return () => {
      this.setState({
        deleteProductId: id
      })
    }
  }

  onConfirmDeleteProduct(proceed) {
    if (proceed) {
      this.props.deleteProduct(this.state.deleteProductId)
    }
    else {
      this.setState({
        deleteProductId: null
      })
    }
  }

  render() {
    const category = this.props.list && this.state.selected
      ? _.find(
          this.props.list,
          (category) => (category.id === this.state.selected)
        )
      : undefined
    return (
      <React.Fragment>
        <Page direction={Page.DIRECTION.ROW}>
          <Page.Element
            flex='3 3 60%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Header
              style={{
                flex: '0 1 auto'
              }}
              title='Catégories'
              right={
                <React.Fragment>
                  <Grant role={Grant.ROLE.MANAGE}>
                    <Button
                      compact={true}
                      icon='sliders'
                      content='Gérer les couleurs'
                      onClick={this.onClickManageColors}
                    />
                  </Grant>
                  <Grant role={Grant.ROLE.MANAGE}>
                    <Button
                      compact={true}
                      icon='plus'
                      content='Créer'
                      color='green'
                      onClick={this.onClickCreateCategory}
                    />
                  </Grant>
                </React.Fragment>
              }
            />
            <Table
              columns={[
                // Nom
                ColumnsProvider.genericName,
                // Couleur
                ColumnsProvider.genericColor,
                // Actions
                ColumnsProvider.categoryActions(this)
              ]}
              data={this.props.list}
              error={this.props.error}
              isLoading={this.props.isFetching}
              emptyMessage="Il n'existe aucune catégorie pour le moment."
              selectedId={this.state.selected}
            />
          </Page.Element>
          <Page.Element
            flex='2 2 40%'
            style={{
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {
              category
                ? <React.Fragment>
                    <Header
                      style={{
                        flex: '0 1 auto'
                      }}
                      title='Matériel'
                      center={
                        <span style={{
                          lineHeight: '36px'
                        }}>
                          {`(${category.name})`}
                        </span>
                      }
                      right={
                        <Grant role={Grant.ROLE.MANAGE}>
                          <Button
                            compact={true}
                            icon='plus'
                            content='Créer'
                            color='green'
                            onClick={this.onClickCreateProduct}
                          />
                        </Grant>
                      }
                    />
                    <Table
                      columns={[
                        // Nom
                        ColumnsProvider.genericName,
                        // Actions
                        ColumnsProvider.productActions(this)
                      ]}
                      data={category.products}
                      error={null}
                      isLoading={this.props.isFetching}
                      emptyMessage="Il n'existe aucun matériel dans cette catégorie pour le moment."
                      color='yellow'
                    />
                  </React.Fragment>
                : <Message
                    info={true}
                    content='Sélectionnez une catégorie pour voir le matériel associé.'
                  />
            }

          </Page.Element>
        </Page>
        {
          this.state.isColorsPopupOpen
            ? <ManageColorsPopup
                onClose={this.onCloseManageColors}
              />
            : null
        }
        {
          this.state.isCreateCategoryPopupOpen
            ? <CreateCategoryPopup
                onClose={this.onCloseCreateCategory}
              />
            : null
        }
        {
          !_.isNull(this.state.updateCategoryPopupId)
            ? <UpdateCategoryPopup
                id={this.state.updateCategoryPopupId}
                onClose={this.onCloseUpdateCategory}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteCategoryId)
            ? <Confirm
                header="Suppression d'une catégorie"
                body="Êtes-vous sûr de vouloir supprimer cette catégorie ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.categoryDeleteIsFetching}
                callback={this.onConfirmDeleteCategory}
              />
            : null
        }
        {
          this.state.isCreateProductPopupOpen
            ? <CreateProductPopup
                category={_.find(this.props.list, (category) => (category.id === this.state.selected))}
                onClose={this.onCloseCreateProduct}
              />
            : null
        }
        {
          !_.isNull(this.state.updateProductPopupId)
            ? <UpdateProductBasicPopup
                id={this.state.updateProductPopupId}
                onClose={this.onCloseUpdateProduct}
              />
            : null
        }
        {
          !_.isNull(this.state.deleteProductId)
            ? <Confirm
                header="Suppression d'un matériel"
                body="Êtes-vous sûr de vouloir supprimer ce matériel ?"
                confirmText='Supprimer'
                confirmColor='red'
                confirmIcon='trash'
                isProceeding={this.props.productDeleteIsFetching}
                callback={this.onConfirmDeleteProduct}
              />
            : null
        }
      </React.Fragment>
    )
  }
}

ProductsManagePage.propTypes = {
  // Properties

  // Redux State
  list: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
  error: PropTypes.object,
  categoryReorderId: PropTypes.number,
  categoryReorderData: PropTypes.object,
  categoryReorderIsFetching: PropTypes.bool.isRequired,
  categoryReorderError: PropTypes.object,
  categoryDeleteIsFetching: PropTypes.bool.isRequired,
  categoryDeleteError: PropTypes.object,
  productReorderId: PropTypes.number,
  productReorderData: PropTypes.object,
  productReorderIsFetching: PropTypes.bool.isRequired,
  productReorderError: PropTypes.object,
  productDeleteIsFetching: PropTypes.bool.isRequired,
  productDeleteError: PropTypes.object,

  // Redux Actions
  fetch: PropTypes.func.isRequired,
  clearError: PropTypes.func.isRequired,
  reorderCategory: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  reorderProduct: PropTypes.func.isRequired,
  deleteProduct: PropTypes.func.isRequired
}

export default connect(
  (state) => ({
    list: state.entities.categories.list.data,
    isFetching: state.entities.categories.list.isFetching,
    error: state.entities.categories.list.error,
    categoryReorderId: state.entities.categories.reorder.id,
    categoryReorderData: state.entities.categories.reorder.data,
    categoryReorderIsFetching: state.entities.categories.reorder.isFetching,
    categoryReorderError: state.entities.categories.reorder.error,
    categoryDeleteIsFetching: state.entities.categories.delete.isFetching,
    categoryDeleteError: state.entities.categories.delete.error,
    productReorderId: state.entities.products.reorder.id,
    productReorderData: state.entities.products.reorder.data,
    productReorderIsFetching: state.entities.products.reorder.isFetching,
    productReorderError: state.entities.products.reorder.error,
    productDeleteIsFetching: state.entities.products.delete.isFetching,
    productDeleteError: state.entities.products.delete.error
  }),
  (dispatch) => ({
    fetch: () => (dispatch(ListAction({}))),
    clearError: () => (dispatch(ClearErrorAction(Types.CATEGORIES.LIST))),
    reorderCategory: (id, data) => (dispatch(ReorderCategoryAction({ id, data }))),
    deleteCategory: (id) => (dispatch(DeleteCategoryAction({ id }))),
    reorderProduct: (id, data) => (dispatch(ReorderProductAction({ id, data }))),
    deleteProduct: (id) => (dispatch(DeleteProductAction({ id })))
  })
)(ProductsManagePage)



// WEBPACK FOOTER //
// ./src/containers/pages/ProductsManagePage.js